import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class CommandeService {
  constructor(private httpClient: HttpClient) {}

  getData() {
    return this.httpClient.get(environment.Localurl + "commande");
  }

  insertData(data) {
    return this.httpClient.post(environment.Localurl + "commande", data);
  }

  deleteData(id) {
    return this.httpClient.delete(environment.Localurl + "commande/" + id);
  }

  getOneData(id) {
    return this.httpClient.get(environment.Localurl + "commande/" + id);
  }

  updateData(id, data) {
    return this.httpClient.put(environment.Localurl + "commande/" + id, data);
  }
  GetCommandeEncours() {
    return this.httpClient.get(environment.Localurl + "commande/Encours");
  }
  updateEtatCommandeEncours(id) {
    return this.httpClient.get(
      environment.Localurl + "commande/updateCommandeEncours/" + id
    );
  }

  updateEtatCommandeLivre(id) {
    return this.httpClient.get(
      environment.Localurl + "commande/updateCommandeEtatLivre/" + id
    );
  }
  updateEtatCommande(id) {
    return this.httpClient.get(
      environment.Localurl + "commande/updateCommandeEtatNonTermine/" + id
    );
  }
  getCommandeDateNow() {
    return this.httpClient.get(
      environment.Localurl + "commande/getCommandeNow"
    );
  }
  GetNombreCommandeDateNow() {
    return this.httpClient.get(environment.Localurl + "commande/Encours");
  }
  GetNombreCommandePasser() {
    return this.httpClient.get(environment.Localurl + "commande/Encours");
  }
  getCommandeDatePast() {
    return this.httpClient.get(
      environment.Localurl + "commande/getCommandePast"
    );
  }
  getCommandeDateFuture() {
    return this.httpClient.get(
      environment.Localurl + "commande/getCommandeFutur"
    );
  }

  SendMail(data) {
    console.log(data);
    return this.httpClient.get(environment.Localurl + "commande/Encours");
  }
  GetNombreClient() {
    return this.httpClient.get(environment.Localurl + "commande/Encours");
  }
  GetMontantTotal() {
    return this.httpClient.get(environment.Localurl + "commande/Encours");
  }
  GetMontantTotalVente() {
    return this.httpClient.get(environment.Localurl + "commande/Encours");
  }
  GetDelaiCommandeByDay(jour) {
    return this.httpClient.get(
      environment.Localurl + "commande/AlertCommandeDate/" + jour
    );
  }
  updateEtatCommandeEncour(id) {
    return this.httpClient.get(environment.Localurl + "commande/Encours");
  }
  UpdateAvance(id, Newavance) {
    return this.httpClient.get(environment.Localurl + "UpdateAvanceCommande/" + id +"/"+ Newavance);
  }
}
